import {
  IFilter,
  INewDocuments,
  INotification,
} from '@/interfaces/common.model';
import { IsalaryDetail } from '@/interfaces/employee.model';
import moment from 'moment';
import cookies from 'react-cookies';
import toast from 'react-hot-toast';
import { RoutesLink } from './RouteLinks';
import React from 'react';
/**
 * common function to set cookies in react application
 * @param name name of cookie
 * @param value value to set in cookie
 */
export const setCookies = (name: string, value: string | object) => {
  cookies.save(name, value, { path: import.meta.env.VITE_PUBLIC_URL });
};
/**
 *
 * @param name find cookies by name
 * @returns
 */
export const getCookies = (name: string) => {
  return cookies.load(name);
};
export const getCurrentFinancialYear = () => {
  const today = moment();
  const startYear = today.month() < 3 ? today.year() - 1 : today.year();
  //current year
  return `${startYear}-${startYear + 1}`;
  //2024-2025
  // return `${startYear - 1}-${startYear}`;
};

/**
 *
 * @param name Delete cookies by name
 * @returns
 */
export const deleteCookies = (name: string) => {
  cookies.remove(name, { path: import.meta.env.VITE_BUSINESS });
};

/**
 *
 * @returns reutn the saved auth token
 */
export const getToken = () => {
  return cookies.load(import.meta.env.VITE_BUSINESS + 'token');
};
export const authChannel = new BroadcastChannel('auth');
export const logoutUser = async () => {
  authChannel.postMessage('logout');
  deleteCookies(import.meta.env.VITE_BUSINESS + 'token');
  deleteCookies(import.meta.env.VITE_BUSINESS + 'refreshToken');
  localStorage.removeItem(import.meta.env.VITE_BUSINESS + 'deviceId');
  localStorage.removeItem(import.meta.env.VITE_BUSINESS + 'fcmToken');
  localStorage.removeItem(import.meta.env.VITE_BUSINESS + '_teamToken');
  window.location.href = '/';
  showToastNotification('success', 'Logged out successfully');
};
export function toFixedThree(input: string | number, fixedTo = 3) {
  return parseFloat(input.toString()).toFixed(fixedTo);
}

// export const toFixedThree = (price: any) => {
//   const amount = parseFloat(price);
//   const formattedPrice = new Intl.NumberFormat('en-BH', {
//     style: 'currency',
//     currency: 'BHD',
//     minimumFractionDigits: 3,
//   }).format(amount);
//   return formattedPrice;
// };

/**
 *
 * @param type type of toast notification
 * @param message message to show in toast notification
 */

export const showToastNotification = (
  type: 'success' | 'danger' | 'info' | 'default' | 'warning',
  message: string,
) => {
  const commonOptions = {
    position: 'top-right' as const,
    duration: 5000,
  };

  let displayMessage = message;
  const jwtKeywords = [
    'jwt',
    'token expired',
    'session expired',
    'malformed',
    'invalid token',
    'invalid signature',
  ];

  if (type === 'danger' && message) {
    const shouldHide = jwtKeywords.some((keyword) =>
      message.toLowerCase().includes(keyword),
    );
    if (shouldHide) {
      displayMessage = 'Something went wrong';
    }
  }

  const createToastWithClose = (
    toastFn: typeof toast | typeof toast.success | typeof toast.error,
    icon?: string,
  ) => {
    return toastFn(
      (t) =>
        React.createElement(
          'div',
          {
            style: {
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            },
          },
          React.createElement('span', { style: { flex: 1 } }, displayMessage),
          React.createElement(
            'button',
            {
              onClick: () => toast.dismiss(t.id),
              style: {
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                fontSize: '16px',
                opacity: 0.7,
                padding: '0',
                marginLeft: '8px',
              },
            },
            '✕',
          ),
        ),
      { ...commonOptions, icon },
    );
  };

  switch (type) {
    case 'success':
      return createToastWithClose(toast.success);
    // return toast.success(displayMessage, commonOptions);

    case 'danger':
      // react-hot-toast doesn't have "danger" alias — use error
      return createToastWithClose(toast.error);
    // return toast.error(displayMessage, commonOptions);

    case 'warning':
      return createToastWithClose(toast, '⚠️');
    // return toast(displayMessage, {
    //   ...commonOptions,
    //   icon: '⚠️',
    // });

    case 'info':
      // info — use a plain toast or use a custom icon if you want
      return createToastWithClose(toast);
    // return toast(displayMessage, commonOptions);

    case 'default':
    default:
      return createToastWithClose(toast);
    // return toast(displayMessage, commonOptions);
  }
};
export const orderByList = [
  { value: '', name: 'Newest' },
  { value: 'asc', name: 'Oldest' },
];
export const getFilterUrl = (filter: IFilter) => {
  if (!filter) return '';

  return Object.entries(filter)
    .filter(
      ([, value]) => value !== null && value !== undefined && value !== '',
    )
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`,
    )
    .join('&');
};

export const handleFormDocuments = (
  formData: FormData,
  documents: INewDocuments[] | File[],
) => {
  if (!documents) return;
  for (const doc of documents) {
    const [key, file] = Object.entries(doc)[0];
    if (file) {
      formData.append(key, file);
    }
  }
};
export const permissionKeys = {
  dashboard: 'show',
  company: 'co',
  attendance: 'attendance',
  // extraWork: 'ew',
  leave: 'leave',
  regularization: 'ar',
  wfh: 'wfh',
  payslip: 'paySlip',
  holiday: 'holiday',
  hrmSetting: 'hs',
  assets: 'asts',
  show: 'show',
};

export const menuBars = [
  { label: 'Company', value: permissionKeys.company },
  // { label: 'Project', value: 'show' },
  // { label: 'Sites', value: 'show' },
  // { label: 'Site Salary Head', value: 'show' },

  { label: 'Attendance', value: permissionKeys.attendance },
  { label: 'Assets', value: permissionKeys.assets },
  // { label: 'My Attendance', value: 'attendance' },
  // { label: 'Daily Team Att.', value: 'attendance' },
  // { label: 'Monthly Team Att.', value: 'attendance' },

  // { label: 'Extra Work', value: 'ew' },
  // { label: 'My Extra Work', value: 'ew' },
  // { label: 'Team Extra Work', value: 'ew' },

  { label: 'Leave', value: permissionKeys.leave },
  // { label: 'My Leave', value: 'leave' },
  // { label: 'Team Leave', value: 'leave' },

  { label: 'Att. Regularization', value: permissionKeys.regularization },
  // { label: 'My A.R.', value: 'ar' },
  // { label: 'Team A.R.', value: 'ar' },

  { label: 'WFH', value: permissionKeys.wfh },
  // { label: 'My O.D.', value: 'od' },
  // { label: 'Team O.D.', value: 'od' },

  // { label: 'Reimbursement', value: 'rf' },
  // { label: 'My Reimb.', value: 'rf' },
  // { label: 'Team Reimb.', value: 'rf' },

  { label: 'Payslip', value: permissionKeys.payslip },
  // { label: 'My Payslip', value: 'paySlip' },
  // { label: 'Team Payslip', value: 'paySlip' },

  { label: 'Holidays', value: permissionKeys.holiday },

  { label: 'HRM Settings', value: permissionKeys.hrmSetting },
  // { label: 'Shift & Time Config', value: 'hs' },
  // { label: 'Employee Onboard', value: 'hs' },
  // { label: 'Salary Head', value: 'hs' },
  // { label: 'Holiday Setting', value: 'hs' },
  // { label: 'Office Location', value: 'hs' },
  // { label: 'Designation', value: 'hs' },
  // { label: 'Leave Setting', value: 'hs' },
  // { label: 'Site Salary Config', value: 'hs' },
  // { label: 'Deparment', value: 'hs' },

  // { label: 'Debit Note', value: 'dn' },
  // { label: 'TDS Ledger', value: 'tl' },
];
export const statesData = [
  'AndhraPradesh',
  'ArunachalPradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'HimachalPradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'MadhyaPradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'TamilNadu',
  'Telangana',
  'Tripura',
  'UttarPradesh',
  'Uttarakhand',
  'WestBengal',
] as const;
export const relationTypes = [
  'Father',
  'Mother',
  'Brother',
  'Sister',
  'Spouse',
  'Son',
  'Daughter',
  'Uncle',
  'Aunt',
  'Grandfather',
  'Grandmother',
] as const;
export const handleFormatAmount = (amount: number | string) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
  }).format(Number(amount) || 0);
};

export const calculateSalaryValues = (salaryDetail: IsalaryDetail) => {
  const earnings = salaryDetail?.earning || [];
  const deductions = salaryDetail?.deduction || [];

  // Identify core earnings dynamically (excluding basic salary which is handled separately in some logic,
  // but included in the earnings array)
  // We sum everything in 'earning' that isn't a calculated field (Gross, Net, Daily)
  // AND isn't Basic Salary (because we show it as a separate label in the Breakdown Card)

  const isCalculated = (name: string) => {
    const lowerName = name?.toLowerCase()?.trim() || '';
    return (
      [
        'gross salary',
        'net salary',
        'daily wage',
        'daily wages',
        'net pay',
      ].includes(lowerName) || ['gross', 'net', 'daily'].includes(lowerName)
    );
  };

  const grossAllowances = earnings.reduce((acc, curr) => {
    const name = curr?.salaryhead?.name || '';
    if (!isCalculated(name) && name.toLowerCase() !== 'basic salary') {
      return acc + (Number(curr.amount) || 0);
    }
    return acc;
  }, 0);

  const finalBasicSalary = Number(salaryDetail?.basicSalary || 0);
  const sumFromEmployer = Number(salaryDetail?.sumOfFromEmployer || 0);
  const finalNetSalary = Number(salaryDetail?.netSalary || 0);

  // Gross Income = Basic Salary + Total Allowances
  const grossIncome = finalBasicSalary + grossAllowances;

  // CTC = Gross Income + Total Employer Contribution
  const ctc = grossIncome + sumFromEmployer;

  // For total deductions, use the full list
  const totalDeductionsMonthly = deductions.reduce(
    (acc, curr) => acc + (Number(curr.amount) || 0),
    0,
  );

  return {
    basicSalary: finalBasicSalary,
    netSalary: finalNetSalary,
    grossAllowances,
    grossIncome,
    ctc,
    totalEarningsMonthly: grossAllowances, // Treat this as the primary earnings for display
    totalFromEmployerMonthly: sumFromEmployer,
    totalDeductionsMonthly,
  };
};
export const genderHandler = (value: number) => {
  if (value === 0) {
    return 'Male';
  } else if (value === 1) {
    return 'Female';
  } else if (value === 2) {
    return 'Other';
  } else {
    return 'Prefer not to say';
  }
};

export function calculateDuration(fromDate: string, toDate: string) {
  const from = new Date(fromDate);
  const to = toDate ? new Date(toDate) : new Date();

  // Calculate the difference in total months
  const years = to.getFullYear() - from.getFullYear();
  const months = to.getMonth() - from.getMonth();

  // Calculate total months difference
  const totalMonths = years * 12 + months;

  // If duration is less than 12 months, return in months
  if (totalMonths < 12) {
    return `${totalMonths} month${totalMonths > 1 ? 's' : ''}`;
  }

  // Otherwise, return in years and months
  const remainingMonths = totalMonths % 12;
  const fullYears = Math.floor(totalMonths / 12);
  return `${fullYears} year${fullYears > 1 ? 's' : ''} ${
    remainingMonths > 0
      ? `${remainingMonths} month${remainingMonths > 1 ? 's' : ''}`
      : ''
  }`;
}
export const formatTo12HourTime = (dateString: string) => {
  if (!dateString) return '';

  try {
    // if (dateString.includes('T')) {
    //   const timePart = dateString.split('T')[1];
    //   if (timePart) {
    //     const [hourStr, minuteStr] = timePart.split(':');
    //     let hours = parseInt(hourStr, 10);
    //     const minutes = minuteStr?.padStart(2, '0') ?? '00';
    //     const ampm = hours >= 12 ? 'PM' : 'AM';
    //     hours = hours % 12 || 12;
    //     return `${hours.toString().padStart(2, '0')}:${minutes} ${ampm}`;
    //   }
    // }

    const date = new Date(dateString);

    if (!isNaN(date.getTime())) {
      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      return `${hours.toString().padStart(2, '0')}:${minutes} ${ampm}`;
    }
    return '';
  } catch {
    return '';
  }
};

export const fallbackPermissionKeys = [
  permissionKeys?.leave,
  permissionKeys?.attendance,
  permissionKeys?.regularization,
  permissionKeys?.wfh,
  permissionKeys?.hrmSetting,
  permissionKeys?.company,
  permissionKeys?.holiday,
  permissionKeys?.payslip,
  permissionKeys?.dashboard,
  permissionKeys.assets,
];

export const capitalizeFirstLetter = (str: string) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const toMinutes = (time: string) => {
  const [h, m] = time.split(':').map(Number);
  return h * 60 + m;
};

export const getNotificationUrl = (item: INotification) => {
  const type = item?.data?.type;
  const id = item?.data?.[type + 'Id'];

  if (type === 'attendance') return RoutesLink.arRequestDetail + `/${id}`;
  if (type === 'odRequest') return RoutesLink.wfhRequestDetail + `/${id}`;
  if (type === 'leave') return RoutesLink.leaveDetail + `/${id}`;

  return '#';
};

export const getDateOnly = (isoString: string) => {
  if (!isoString) return '';
  return isoString.split('T')[0];
};
export const parseKey = (key: string) => {
  if (/^[0-9a-fA-F]+$/.test(key) && key.length === 64) {
    return CryptoJS.enc.Hex.parse(key);
  }
  return CryptoJS.enc.Utf8.parse(key);
};

export const attendanceStatus = [
  { value: 1, label: 'Present' },
  { value: 0, label: 'Absent' },
  { value: 2, label: 'Pending' },
  { value: 3, label: 'On Leave' },
];

export const assetStatus = [
  { value: 0, label: 'Assigned' },
  { value: 1, label: 'Available' },
  { value: 2, label: 'In Service' },
  { value: 3, label: 'Discard' },
];

export const formatISTTime = (checkInTime: string) => {
  const localDate = new Date(checkInTime?.replace('Z', ''));
  const formattedTime = localDate.toLocaleTimeString('en-IN', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  return formattedTime;
};

export const getRedirectUri = () => {
  const redirectUri = window.location.origin + '/';
  console.log('redirectUri', redirectUri);
  return redirectUri;
};

export const assetRequestStatus = [
  { value: 0, label: 'Pending' },
  { value: 1, label: 'Approved' },
  { value: 2, label: 'Rejected' },
  { value: 3, label: 'Received' },
];

export const handlePaySlipCalculation = (
  grossSalary: number | string,
  deduction: number | string,
) => {
  const gross = Number(grossSalary) || 0;
  const deduct = Number(deduction) > 0 ? Number(deduction) : 0;
  const net = gross - deduct;
  return {
    deductionAmount: deduct,
    netSalary: net,
  };
};
